import React, { lazy } from "react";
import { Route } from "react-router";
import routeURL from "./routeConstants";

const RunsList = lazy(() => import("../pages/RunsList"));
const RunDetail = lazy(() => import("../pages/RunDetail"));
const TransactionDetail = lazy(() => import("../pages/TransactionDetail"));

const migrationValidationRoutes = (
  <>
    <Route path={routeURL.RUNS} component={RunsList} />
    <Route path={routeURL.RUN_DETAIL} component={RunDetail} />
    <Route path={routeURL.TRANSACTION_DETAIL} component={TransactionDetail} />
  </>
);

export default migrationValidationRoutes;
